module.exports = __webpack_public_path__ + "static/media/bella.0fd30adb.png";